if (!customElements.get('c-collapse')) {
  class Collapse extends HTMLElement {
    constructor() {
      super();
      this.el = this.querySelector('details');
      if (!this.el) return;
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.el.addEventListener('mouseenter', this.open.bind(this));
      this.el.addEventListener('mouseleave', this.close.bind(this));
      this.el.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    open() {
      this.el.setAttribute('open', '');
    }

    close() {
      this.el.removeAttribute('open');
    }
  }

  customElements.define('c-collapse', Collapse);
}
